// biome-ignore lint/nursery/noRestrictedImports:
import { gql } from '@apollo/client';

export const getFrequencyReporting = gql`
query getFrequencyReporting($startDate: String!, $endDate: String!) {
  optimizeFrequencyReporting(startDate: $startDate, endDate: $endDate) {
    messageMediumData {
      messageMedium
      holdoutOpens
      optimizedOpens
      holdoutClicks
      optimizedClicks
      holdoutSends
      optimizedSends
      holdoutUnsubscribes
      optimizedUnsubscribes
      holdoutSendSkips
      optimizedSendSkips
      holdoutOpenRate
      optimizedOpenRate
      openRateLift
      holdoutClickRate
      optimizedClickRate
      clickRateLift
      holdoutUnsubscribeRate
      optimizedUnsubscribeRate
      unsubscribeRateLift
      holdoutSendSkipRate
      optimizedSendSkipRate
      holdoutClickRateChange
      optimizedClickRateChange
      holdoutOpenRateChange
      optimizedOpenRateChange
      holdoutUnsubscribeRateChange
      optimizedUnsubscribeRateChange
      holdoutUsers
      optimizedUsers
      weeklyHoldoutSendsPerUser
      weeklyOptimizedSendsPerUser
    }
    messageTypeData {
      messageMedium
      messageTypeId
      holdoutSends
      optimizedSends
      holdoutOpens
      optimizedOpens
      holdoutClicks
      optimizedClicks
      holdoutUnsubscribes
      optimizedUnsubscribes
      holdoutSendSkips
      optimizedSendSkips
      holdoutOpenRate
      optimizedOpenRate
      holdoutClickRate
      optimizedClickRate
      holdoutUnsubscribeRate
      optimizedUnsubscribeRate
      openRateLift
      clickRateLift
      unsubscribeRateLift
      holdoutSendSkipRate
      optimizedSendSkipRate
      topCampaignIds
    }
    cardData {
      largestLiftMedium
      largestLiftMetric
      largestLiftValue
      largestChangeMedium
      largestChangeMetric
      largestChangeValue
    }
    rawData {
      messageMedium
      projectId
      messageTypeId
      frequencyPeriod
      startDate
      endDate
      holdoutUsers
      optimizedUsers
      holdoutSends
      holdoutSendSkips
      optimizedSends
      optimizedSendSkips
      holdoutOpens
      holdoutClicks
      holdoutUnsubscribes
      optimizedOpens
      optimizedClicks
      optimizedUnsubscribes
      holdoutOpenRate
      optimizedOpenRate
      openRateLift
      holdoutClickRate
      optimizedClickRate
      clickRateLift
      holdoutUnsubscribeRate
      optimizedUnsubscribeRate
      unsubscribeRateLift
      holdoutSendSkipRate
      optimizedSendSkipRate
    }
    messageMediumByTimeData {
      frequencyPeriod
      data {
        messageMedium
        startDate
        endDate
        frequencyPeriod
        holdoutSends
        optimizedSends
        holdoutOpens
        optimizedOpens
        holdoutClicks
        optimizedClicks
        holdoutUnsubscribes
        optimizedUnsubscribes
        holdoutSendSkips
        optimizedSendSkips
        holdoutUsers
        optimizedUsers
        holdoutOpenRate
        optimizedOpenRate
        holdoutClickRate
        optimizedClickRate
        holdoutUnsubscribeRate
        optimizedUnsubscribeRate
        openRateLift
        clickRateLift
        unsubscribeRateLift
        holdoutSendSkipRate
        optimizedSendSkipRate
        }
    }
  }
}
`;
